// stores/loadingStore.js
import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isActive: false,
    text: '加载中...',
    backgroundColor: 'rgba(255, 255, 255, 0.8)'
  }),

  actions: {
    // 显示loading
    show(text = '加载中...', backgroundColor) {
      this.isActive = true;
      this.text = text;
      if (backgroundColor) {
        this.backgroundColor = backgroundColor;
      }
    },

    // 隐藏loading
    hide() {
      this.isActive = false;
    }
  }
});
